//#region src/givex_api_server.ts
var GivexApiServer = /* @__PURE__ */ function(GivexApiServer) {
	GivexApiServer[GivexApiServer["Sandbox"] = 1] = "Sandbox";
	GivexApiServer[GivexApiServer["Beta"] = 2] = "Beta";
	GivexApiServer[GivexApiServer["ProductionUs"] = 3] = "ProductionUs";
	GivexApiServer[GivexApiServer["ProductionCa"] = 4] = "ProductionCa";
	GivexApiServer[GivexApiServer["ProductionPt"] = 5] = "ProductionPt";
	return GivexApiServer;
}(GivexApiServer || {});
//#endregion
export { GivexApiServer };

//# sourceMappingURL=givex_api_server.js.map